<template>
  <div class="pl-2 ml-2 d-flex flex-column" style="max-width: 450px">
    <div style="display: flex;">
      <!-- text -->
      <div class="mr-2 d-flex flex-column"> 
        <div class="mt-3">Description:</div>
        <div class="mt-5">Business role: </div>
        <div class="mt-5">Mapping name: </div>
      </div>
      <!-- input fields -->
      <div class="mr-2 d-flex flex-column">
        <input
          class="company-mail-endings-details-input mt-3"
          ref="entraidmapper-input"
          v-model="new_description"
          >
        <DropDownOutlinedFlat
          class=" mt-3"
          :options="roles_for_dropdown"
          @change="new_brole_id = $event"
          :value="new_brole_id"
          :width="300"
          :height="10"
          foreground_color="#fff"
          background_color="#000"
          />
        <input
        class="company-mail-endings-details-input mt-3"
        ref="entraidmapper-input"
        v-model="new_mapping_name"
        >
      </div>
    </div>
    <!-- button + error -->
    <div class="mt-2 d-flex align-center flex-column">
      <v-btn
        class="mt-2 align-center"
        color="green"
        :disabled="is_submit_disabled"
        @click="createUObject({
          url: [
            {businesses: business.id},
            {entraidmappers: ''},
            {showWithEntitiesNormalized: ''}
          ],
          u_object: {
            brole_id: new_brole_id,
            mapping_name: new_mapping_name,
            description: new_description
          },
          resp_data: {
            entraidmappers: [
              { brole_id: new_brole_id,
                mapping_name: new_mapping_name,
                description: new_description
              }
            ]
          }
          }).then(() => {
            new_mapping_name = '',
            new_description = ''
            })"
        >
        submit
      </v-btn>
      <div v-if="is_submit_disabled">
        {{error_message}}
      </div>
    </div>
  </div>
</template>

<script>
  import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';
  import { mapActions, mapGetters } from 'vuex';
  export default {
    components: {
      DropDownOutlinedFlat,
    },
    props: [],
    data: () => ({
      new_mapping_name: '',
      new_brole_id: '55',
      new_description: '',
      business_roles: [],
    }),
    created(){
    },
    computed: {
      ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects'
    ]),
      ...mapGetters('Business', [
      'getBusiness',
      'getBusinessRoles',
    ]),
      business() {
        let current_user = this.$store.getters['Auth/getUser'];
        return this.$store.state.Ultra.businesses[current_user.business.id];
      },
      is_submit_disabled() {
        if (this.new_mapping_name === '' | this.new_brole_id.value === '' | this.new_description === '' ) {
          return  true;
        } else {
            return false;
        }
      },
      error_message() {
        if (this.is_submit_disabled) {
          return 'Please make sure all fields are filled!';
        } else {
          return "";
        }
      },
      roles_for_dropdown() {
        let roles = this.getUObjects({type: 'broles', ids: this.business.broles});
        return roles.map(role => {
          return {
            value: role.id,
            text: role.name,
            unit: role.description
          }
        })
      }

    },
    methods: {
      ...mapActions('Ultra', [
      'createUObject',
      'updateUObject',
      'deleteUObject',
      'requestUObject'
    ]),
    }
  }
</script>
<style>
  .class {
  }
</style>
